const URL = '  https://food-mafia-server.herokuapp.com/api/register';

 const addNewUser = (user) =>
    fetch(URL, {
        method: 'POST',
        body: JSON.stringify(user),
        headers: {
            'content-type': 'application/json'
        }
    }).then(response => response.json());
 const findAllUser = () =>
    fetch(URL)
        .then(res => res.json());


// Added by Savitha
const findUser= (userId) => {
    console.log(userId);
    return fetch(`  https://food-mafia-server.herokuapp.com/api/register/${userId}`)
        .then(response => response.json());
}

//Already exporting --> no need to do this.
export default {
    addNewUser, findAllUser, findUser
}